<template>
  <div class="lineOne"></div>
</template>
<script>
var timerId;
import { reqWeekDoc } from "@/network/homePage";
export default {
  name: "BarOne",
  methods: {
    async getInitData() {
      let { data } = await reqWeekDoc();
      // console.log(data, "reqWeekDoc");
      if (data.code == 200) {
        var acticleData = [];
        let Data = data.data.reverse();
        for (const item of Data) {
          // var arr = item.date.split("-");
          // weekData.push(`${arr[1]}.${arr[2]}`);
          acticleData.push(item.total);
        }
      }
      var result = [];
      for (var i = 0; i < acticleData.length; i += 7) {
        result.push(acticleData.slice(i, i + 7));
      }

      this.$echarts.lineone(this.myChart, {
        currentWeek: result[2],
        lastWeek: result[0],
        middleWeek: result[1],
      });
    },
  },
  watch: {
    "$store.state.opened"() {
      if (timerId) {
        // console.log(timerId);
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        this.myChart.resize();
      }, 300);
    },
  },
  mounted() {
    this.myChart = this.$init(document.querySelector(".lineOne"));
    this.getInitData();
  },
};
</script>

<style lang="scss" scoped>
.lineOne {
  width: 100%;
  height: 100%;
}
</style>